import React from 'react'
import { Modal, Button, TextArea } from 'util/ui'
import { isEmpty } from 'util/strings'
import { v4 as uuidV4 } from 'uuid'
import styles from '../../styles.less'

export default class TextQuestionStep extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      answer: null,
    }
    this.componentId = uuidV4()
  }

  handleAnswerChange = (evt, { value }) => {
    this.setState({
      answer: value,
    })
  }

  handleNext = () => {
    const { onNext, question } = this.props
    const { answer } = this.state
    onNext({
      question,
      answer,
    })
  }

  render() {
    const { onCancel, question, open } = this.props
    const { answer } = this.state

    return (
      <Modal open={open} className={styles.billingModal}>
        <Modal.Header>Cancel account</Modal.Header>
        <Modal.Content>
          <div>
            {question.split('\n').map((item, index) => {
              const key = `${this.componentId}-${index}`
              return (
                <p key={key}>
                  {item}
                  <br />
                </p>
              )
            })}
            <p>
              <TextArea
                rows={10}
                placeholder="Type your response here..."
                onChange={this.handleAnswerChange}
              />
            </p>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button positive onClick={onCancel}>
            Nevermind, I don{"'"}t want to cancel
          </Button>
          <Button disabled={isEmpty(answer)} onClick={this.handleNext}>
            Next step
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}
